exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3uU6_OCn {\n  align-items: stretch;\n  border-width: 0;\n  border-style: solid;\n  box-sizing: border-box;\n  display: flex;\n  flex-basis: auto;\n  flex-direction: column;\n  flex-shrink: 0;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  min-height: 0;\n  min-width: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"initial": "_3uU6_OCn"
};